module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/235-tokelau-bde5b320bf87d3aca6dafd7d67b90948.svg";